import { useMutation, useQuery } from '@tanstack/react-query';

import { useAuth } from '@/hooks/use-auth';
import {
  type ProjectRow,
  projectAssignmentService,
} from '@/services/data/ProjectAssignmentService';

export type { ProjectRow } from '@/services/data/ProjectAssignmentService';

export function useUserProjectsList(enabled = true) {
  const { user } = useAuth();
  return useQuery<ProjectRow[]>({
    queryKey: ['projects', 'list-for-save', user?.id],
    enabled: Boolean(user?.id) && enabled,
    queryFn: async () => {
      const result = await projectAssignmentService.listAssignableProjects();
      if (result.error) throw new Error(result.error.message);
      return result.data ?? [];
    },
    staleTime: 10_000,
  });
}

export interface SaveToProjectInput {
  projectId: string;
  artifactId?: string | null;
  artifactKind?: string;
  chatSessionId?: string | null;
}

export function useSaveToProject() {
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (input: SaveToProjectInput) => {
      if (!user?.id) throw new Error('Not signed in');
      const result = await projectAssignmentService.addArtifactToProject(input);
      if (result.error) throw new Error(result.error.message);
    },
  });
}
